package structs.accelbyte.promo

import kotlinx.serialization.Serializable
import structs.accelbyte.common.AccelByteJson
import structs.accelbyte.common.AccelByteSerializable

/**
 * Public metadata for a promo code, fetched without `userId`.
 *
 * Intentionally PII-free: no namespace, no batch name, no campaign
 * description are exposed -- only what a player needs to see whether their
 * code is still valid. Operators wanting deeper detail use the gated admin
 * RPC instead.
 */
@Serializable
data class PromoCodeInfoResponse(
    val codeValue: String,
    val availability: PromoCodeAvailability,
    val outcomeType: PromoOutcomeType? = null
) : AccelByteSerializable {
    override fun toJsonString(): String = AccelByteJson.encodeToString(serializer(), this)
}
